import { ReactElement } from 'react';

import {
   IconFillColor,
   IconSize,
   IconWrapper,
   MoreIconHorizontal,
   StyledFlex,
   Tooltip,
   TooltipLabel,
} from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { StyledPatientAvailabilityPreferenceCellTooltip } from './PatientAvailabilityPreferenceCellTooltip.styled';
import { PatientAvailabilityPreferenceCellAvailabilities } from './PatientAvailabilityPreferenceCellAvailabilities';
import { PatientAvailabilityListItem } from './PatientAvailabilityPreferenceCell.types';

type PatientAvailabilityPreferenceCellTooltipProps = {
   availabilities: PatientAvailabilityListItem[];
};

export const PatientAvailabilityPreferenceCellTooltip = (
   props: PatientAvailabilityPreferenceCellTooltipProps
): ReactElement | null => {
   if (!props.availabilities.length) {
      return null;
   }
   return (
      <StyledFlex direction={'column'} justifyContent={'center'}>
         <Tooltip
            testId={'morePatientAvailabilities'}
            content={
               <div>
                  <TooltipLabel label={translationKeys.preferredDates} />
                  <StyledFlex direction={'column'}>
                     <PatientAvailabilityPreferenceCellAvailabilities availabilities={props.availabilities} />
                  </StyledFlex>
               </div>
            }
         >
            <StyledPatientAvailabilityPreferenceCellTooltip alignItems={'center'} justifyContent={'center'}>
               <IconWrapper
                  testId={'morePatientAvailabilities'}
                  fillColor={IconFillColor.WHITE}
                  size={IconSize.SMALLEST}
               >
                  <MoreIconHorizontal />
               </IconWrapper>
            </StyledPatientAvailabilityPreferenceCellTooltip>
         </Tooltip>
      </StyledFlex>
   );
};
